import { render, staticRenderFns } from "./PrivilegedLogin.vue?vue&type=template&id=15b60624&"
import script from "./PrivilegedLogin.vue?vue&type=script&lang=js&"
export * from "./PrivilegedLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports